module.exports = __webpack_public_path__ + "img/d200712-2.4053ab82.jpg";